import {
  Box,
  TextField,
  Divider,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Chip,
  Typography,
  Paper,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Slide,
  Dialog,
  Button,
  Avatar,
} from "@mui/material";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import moment from "moment";
import { useEffect, useState, forwardRef } from "react";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import Swal from "sweetalert2";
import pr from "../lib/pr";
import format_phone from "../lib/format_phone";
import CheckIcon from "@mui/icons-material/Check";
import { ReactComponent as ReservationIcon } from "../assets/reservation.svg";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { setHours } from "date-fns";
import get_cid from "../lib/get_cid";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const calTheme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          maxHeight: "300px",
          height: "100%",
          overflow: "visible",
        },
      },
    },
  },
});

const icon1Theme = createTheme({
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "blue",
          marginLeft: "5px",
          marginRight: "-6px",
        },
      },
    },
  },
});

const dividerTheme = createTheme({
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "rgba(0, 0, 0, 0.2)",
        },
      },
    },
  },
});

function ReservationTeacher(props) {
  const { login } = props;
  const minDate = new Date(moment().add(-1, "years"));
  const maxDate = new Date(moment().add(+1, "years"));
  const [plan, setPlan] = useState([]); // 수업시간
  const token = localStorage.getItem("token");
  // const [login, setLogin] = useState(loginState);
  const [tcid, setTcid] = useState("");
  const [tdate, setTdate] = useState(moment().format("YYYY-MM-DD"));
  const [rows, setRows] = useState([]);
  const [teacher, setTeacher] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  // const [isClicked, setIsClicked] = useState();
  const [hours, setHours] = useState([]);
  const cid = get_cid();

  const onChangeDate = (newDate) => {
    setTdate(moment(newDate).format("YYYY-MM-DD"));
  };

  const load_data = async () => {
    let result = await axios.post(configState.api + "/gympass/reservation", {
      token: token,
      mcd: login.mcd,
      cid: cid,
      level: login.level,
      tdate: tdate,
    });

    setHours(result.data.hour);
    setRows(result.data.reserve);
  };

  useEffect(() => {
    if (open === true) {
      load_data();
    }
  }, [open, tdate]);

  const openClick = () => {
    setOpen(true);
  };
  const closeClick = () => {
    setOpen(false);
  };

  const onMemberInfo = (params) => {
    const { name, phone } = params;
    Swal.fire({
      html: `<div>${name}</div><div>${format_phone(phone)}</div>`,
    });
  };

  const endClass = async (props) => {
    const { seq, hour } = props;
    Swal.fire({
      html: `
            <div>${hour}시 수업을 종료하겠습니까?</div>
            <div>(수업 종료시 고객들의 평가를 받을 수 있습니다)</div>
            `,
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await axios.post(configState.api + "/gympass/quit_class", {
          token: token,
          mcd: login.mcd,
          cid: cid,
          level: login.level,
          date: moment(tdate).format("YYYY-MM-DD"),
          hour: hour,
        });

        if (result.data.success === 1) {
          load_data();
        }
      }
    });
  };

  return (
    <Box>
      <Dialog
        fullScreen
        open={open}
        onClose={closeClick}
        TransitionComponent={Transition}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={closeClick} />
          <Box
            sx={{
              margin: "16px 0 0 10px",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            내 수업
          </Box>
        </Box>
        <Divider />
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
          <ThemeProvider theme={calTheme}>
            <StaticDatePicker
              name="tdate"
              displayStaticWrapperAs="desktop"
              openTo="day"
              value={tdate}
              onChange={onChangeDate}
              renderInput={(params) => <TextField {...params} />}
            />
          </ThemeProvider>
        </LocalizationProvider>
        <Divider />
        <Box
          sx={{
            marginTop: "20px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "80%",
                textAlign: "left",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              예약현황
            </Box>
            {rows.length === 0 && (
              <Box
                sx={{
                  padding: "20px",
                }}
              >
                예약이 없습니다
              </Box>
            )}
            <Box
              sx={{
                width: "80%",
                marginTop: "15px",
              }}
            >
              {hours.map((item, index) => {
                return (
                  // <>
                  <Box
                    key={index}
                    sx={{
                      // display: 'flex',
                      // alignItems: 'center',
                      // justifyContent: 'space-between',
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          padding: "5px 10px",
                          fontSize: "14px",
                          // background: '#C0C0C0',
                          // color: 'white',
                          fontWeight: "bold",
                          // borderBottom: '1px dotted  gray'
                        }}
                      >
                        {item.shour24.slice(0, 2)}시
                      </Box>
                      {(item.is_quit === "null" || item.is_quit === "N") &&
                        moment().format("YYYY-MM-DD HH:mm") >=
                          moment(tdate + " " + item.shour24).format(
                            "YYYY-MM-DD HH:mm"
                          ) &&
                        moment().subtract(1, "d").format("YYYY-MM-DD HH:mm") <=
                          moment(tdate + " " + item.shour24).format(
                            "YYYY-MM-DD HH:mm"
                          ) && (
                          <Button
                            variant="contained"
                            onClick={() =>
                              endClass({ seq: item.seq, hour: item.shour24 })
                            }
                          >
                            수업종료
                          </Button>
                        )}
                    </Box>
                    <ThemeProvider theme={dividerTheme}>
                      <Divider />
                    </ThemeProvider>
                    <Box
                      sx={{
                        padding: "10px 0",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {rows.map((item1, index1) => {
                        return (
                          item.shour24 === item1.hour && (
                            <Box
                              key={index1}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                // justifyContent: 'space-between',
                                margin: "5px 3px",
                              }}
                            >
                              <Chip
                                variant="outlined"
                                label={item1.name}
                                color={
                                  item1.point === 1 ? "success" : "default"
                                }
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                icon={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {item1.pt_type !== 'GX' ?
                                    <Avatar
                                      sx={{
                                        width: "23px",
                                        height: "23px",
                                        fontSize: "12px",
                                        // margin: '0 5px'
                                      }}
                                    >
                                      {item1.pt_type === "PT_MANAGER"
                                        ? "점장"
                                        : "트레"}
                                    </Avatar>
                                    : null
                                    }
                                    {item1.point === 1 ? (
                                      // <ThemeProvider theme={icon1Theme}>
                                      <CheckIcon
                                        sx={{
                                          fontSize: "14px",
                                          marginLeft: "2px",
                                        }}
                                      />
                                    ) : // </ThemeProvider>
                                    null}
                                  </Box>
                                }
                                onClick={() =>
                                  onMemberInfo({
                                    name: item1.name,
                                    phone: item1.phone,
                                  })
                                }
                              />
                            </Box>
                          )
                        );
                      })}
                    </Box>
                  </Box>

                  // </>
                );
              })}
            </Box>
          </Box>
        </Box>
      </Dialog>
      <ListItem sx={{ textAlign: "center" }} onClick={openClick}>
        <ListItemAvatar>
          <ReservationIcon width="24px" />
        </ListItemAvatar>
        <ListItemText sx={{ textAlign: "left" }}>내 수업</ListItemText>
        <ListItemAvatar>
          <ArrowRightIcon />
        </ListItemAvatar>
      </ListItem>
    </Box>
  );
}

export default ReservationTeacher;
